import * as yup from "yup";

// Los CUIT que empiezan con 30/33/34 son personas juridicas. En esos casos
// "Nombre" y "Apellido" no son la identidad fiscal (esa va en Compania, que es
// lo que se factura) sino la persona de contacto: la que figura como
// "Firmado por" en la orden de servicio. Puede no conocerse al dar de alta.
const esPersonaJuridica = (cuit) =>
  ["30", "33", "34"].includes(String(cuit || "").replace(/\D/g, "").slice(0, 2));

const contacto = (mensaje) =>
  yup.string().when("cuit", {
    is: esPersonaJuridica,
    then: (esquema) => esquema.notRequired(),
    otherwise: (esquema) => esquema.required(mensaje),
  });

const validateCUIT = (cuit) => {
  if (typeof cuit !== "string") return false;
  cuit = cuit.replace(/[-]/g, "");
  if (cuit.length !== 11) return false;

  let coefficients = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
  let total = 0;
  for (let i = 0; i < 10; i++) {
    total += parseInt(cuit[i]) * coefficients[i];
  }
  let mod = total % 11;
  let checkDigit = mod === 0 ? 0 : mod === 1 ? 9 : 11 - mod;

  return checkDigit === parseInt(cuit[10]);
};

// Crear una función que devuelva el esquema según el rol del usuario
export const getClientSchema = (isAdmin) => {
  const baseSchema = {
    name: contacto("El nombre es obligatorio"),
    lastName: contacto("El apellido es obligatorio"),
    company: yup.string().required("La compañía es obligatoria"),
    address: yup.string().required("La dirección es obligatoria"),
    province: yup.string().required("La provincia es obligatoria"),
    cuit: yup
      .string()
      .required("El CUIT es obligatorio")
      .test("CUIT válido", "El CUIT no es válido, ingrese un CUIT válido", validateCUIT),
    email: yup
      .string()
      .email("El email no es válido, ingrese un email válido")
      .required("El email es obligatorio"),
    emailBilling: yup
      .string()
      .email("El email para facturar no es válido, ingrese un email válido")
      .required("El email para facturar es obligatorio"),
    secondaryEmailBilling: yup
      .string()
      .email("El email secundario para facturar no es válido, ingrese un email válido")
      .notRequired(),
    phone: yup
      .string()
      .matches(/^[0-9]+$/, "El teléfono debe contener solo números")
      .required("El teléfono es obligatorio"),
    phoneBilling: yup
      .string()
      .matches(/^[0-9]+$/, "El teléfono para facturar debe contener solo números")
      .required("El teléfono para facturar es obligatorio"),
  };

  // Agregar validaciones específicas para administradores
  if (isAdmin) {
    baseSchema.balance = yup
      .number()
      .required("El Saldo del Cliente es obligatorio")
      .min(0, "El Saldo del Cliente no puede ser negativo");
    
    baseSchema.test = yup
      .boolean()
      .default(false);
  } else {
    // Para no administradores, el balance y test son opcionales
    baseSchema.balance = yup.number().default(0);
    baseSchema.test = yup.boolean().default(false);
  }

  return yup.object().shape(baseSchema);
};

// Exportar una versión por defecto para mantener compatibilidad
const clientSchema = yup.object().shape({
  name: contacto("El nombre es obligatorio"),
  lastName: contacto("El apellido es obligatorio"),
  company: yup.string().required("La compañía es obligatoria"),
  address: yup.string().required("La dirección es obligatoria"),
  province: yup.string().required("La provincia es obligatoria"),
  cuit: yup
    .string()
    .required("El CUIT es obligatorio")
    .test("CUIT válido", "El CUIT no es válido, ingrese un CUIT válido", validateCUIT),
  email: yup
    .string()
    .email("El email no es válido, ingrese un email válido")
    .required("El email es obligatorio"),
  emailBilling: yup
    .string()
    .email("El email para facturar no es válido, ingrese un email válido")
    .required("El email para facturar es obligatorio"),
  secondaryEmailBilling: yup
    .string()
    .email("El email secundario para facturar no es válido, ingrese un email válido")
    .notRequired(),
  phone: yup
    .string()
    .matches(/^[0-9]+$/, "El teléfono debe contener solo números")
    .required("El teléfono es obligatorio"),
  phoneBilling: yup
    .string()
    .matches(/^[0-9]+$/, "El teléfono para facturar debe contener solo números")
    .required("El teléfono para facturar es obligatorio"),
  balance: yup
    .number()
    .required("El Saldo del Cliente es obligatorio")
    .min(0, "El Saldo del Cliente no puede ser negativo"),
});

export default clientSchema;
